// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { UserTypes } from '@interfaces/user.interfaces';
import { UserService } from '@services/user.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HelpPageResolver implements Resolve<any[]> {
    constructor(private userService: UserService) {}

    resolve(): Observable<any[]> {
        const questionType = this.userService.user.userType === UserTypes.Customer ? 'isBuyer' : 'isDealer';

        return forkJoin([
            this.userService.getUserFAQ$('faq').pipe(),
            this.userService.getUserFAQ$('emailReason').pipe(
                map((messages) => {
                    return (messages = messages.filter((m) => m[questionType]));
                })
            ),
        ]);
    }
}
